import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import storePageQuery from './query.graphql';

const StorePage = loadable(
  () => import(/* webpackChunkName: "store" */ './store'),
  {
    fallback: <Loader />,
  }
);

StorePage.graphQL = storePageQuery;

StorePage.variables = ({ id, notification }) => ({
  id: typeof id === 'number' ? id : parseInt(id, 10),
  offset: 0,
  // Invalidate store reviews cache if anonymous review was verified
  invalidateCache:
    notification === 'verify-success' || notification === 'delete-success',
  userReviewFilter: 'ALL',
});

export default StorePage;
